import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

/** Custom Prev Arrow */
function PrevArrow({ onClick }) {
  return (
    <div
      className="absolute left-0 top-1/2 transform -translate-y-1/2 z-20 cursor-pointer text-[#2c2087] text-3xl"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </div>
  );
}

/** Custom Next Arrow */
function NextArrow({ onClick }) {
  return (
    <div
      className="absolute right-0 top-1/2 transform -translate-y-1/2 z-20 cursor-pointer text-[#2c2087] text-3xl"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </div>
  );
}

const drives = [
  {
    name: 'Subam Singh',
    role: 'Management Trainee',
    package: '7 LPA',
    company: 'SIS Limited',
    logo: '/assets/placements/2.jpeg',
  },
  {
    name: 'Param Taimni',
    role: 'Management Trainee',
    package: '7 LPA',
    company: 'SIS Limited',
    logo: '/assets/placements/3.jpeg',
  },
  {
    name: 'Shri Hari Gudapelly',
    role: 'Gen AI Engineer',
    package: '5.4 LPA',
    company: 'Xebia Pvt. Ltd.',
    logo: '/assets/placements/1.jpeg',
  },
  {
    name: 'Tushar Virwal',
    role: 'Head of Information Technology',
    package: '3.6 LPA',
    company: 'TLC Heritage Of India',
    logo: '/assets/placements/4.jpeg',
  },
  //   {
  //     company: 'Meta',
  //     role: 'UX Designer',
  //     package: 'May 05, 2025',
  //     logo: '/assets/placements/5.png',
  //   },
];

export default function PlacementDrive() {
  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="bg-gray-50 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* <h2 className="text-3xl font-bold text-[#2c2087] mb-6 text-center">
          Placement Drive
        </h2> */}
        <div className="flex justify-center pb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2c2087]  border-b-[3px] border-[#2c2087] py-1">
            Placement Drive
          </h2>
        </div>
        <Slider {...settings} className="px-5">
          {drives.map((drive, idx) => (
            <div key={idx} className="px-3">
              <div className="bg-[#2c2087] rounded-lg shadow-md flex flex-col items-center">
                <img
                  src={drive.logo}
                  alt={drive.name}
                  className="w-full rounded-lg object-contain"
                />
                {/* <h3 className="text-xl font-semibold text-white pb-3">
                  {drive.name}
                </h3>
                <p className="text-white">{drive.role}</p>
                <p className="text-xl font-bold text-white mt-1">
                  {drive.company}
                </p>
                <p className="text-xl font-bold text-white mt-1">
                  {drive.package}
                </p> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
